/**
 * Types common for more than one Facebook channel
 * (for example WhatsApp Cloud API and Messenger in the same time)
 */
export namespace Facebook {

    export namespace Message {

        /**
         * Message special contents
         */
        export interface Special {

            referral?: Facebook.Referral;

        }
    }

    export type Referral = {
        source_type: ReferralSourceType;
        source_id: string;
        source_url: string;
        headline: string;
        media_type: ReferralMediaType;
    } & ({
        media_type: ReferralMediaType.image;
        /**
         * Image file ID
         */
        image: string;
    } | {
        media_type: ReferralMediaType.video;
        /**
         * Video file ID
         */
        video: string;
        /**
         * Thumbnail file ID
         */
        thumbnail: string;
    });

    export enum ReferralMediaType {
        image = 'image',
        video = 'video',
    }

    /**
     * @todo Add all types
     */
    export enum ReferralSourceType {
        post = 'post',
        ad = 'ad',
    }
}
